import React from 'react';

export const renderSlotData = (current, max) => {
  const slot = () => {
    if (!max) return { text: `Not available`, colClass: 'grey' };
    if (current < max) return { text: `${max - current} left` };
    if (current === max) return { text: `Full`, colClass: 'grey' };
    if (current > max) return { text: `${current} out of ${max}`, colClass: 'red' };
    return null;
  };

  const { text, colClass } = slot();
  return <span className={colClass}>{text}</span>;
};

export const displayCollectionDeliveryOption = (garage, collectionDeliveryOption) => {
  if (collectionDeliveryOption === 'CustomerC&D') return 'CustomerC&D';
  if (garage.deliveryOptions.length > 0) return garage.deliveryOptions[0].deliveryOption;
  return null;
};

export const isCustomerCD = (collectionDeliveryOption) => collectionDeliveryOption === 'CustomerC&D';

export const isGarageCnd = (collectionDeliveryOption) => collectionDeliveryOption === 'GarageC&D';

export const operationsRateExist = (operations) => operations.labourRate && operations.mot;

export const getGarageIdsFromExistingInvites = (garageInvites) =>
  garageInvites.filter(({ status }) => ['pending', 'draft'].includes(status)).map(({ garageId }) => garageId);

export const filterGaragesBySupportedWeight = (garages, vehicleWeight) =>
  garages.filter((g) => g.vehicleWeightCapacity > vehicleWeight);

export const filterGaragesByExistingInvitations = (garages, existingGarageInvites) => {
  const garageIdsToIgnore = getGarageIdsFromExistingInvites(existingGarageInvites);

  return garages.filter(({ garageId }) => !garageIdsToIgnore.includes(garageId));
};

export const filterGaragesBySearchInput = (garages, searchInput) => {
  if (!searchInput || searchInput === '') return garages;

  const searchInputLowerWithoutSpaces = searchInput.toLowerCase();

  const filteredGarages = garages.filter((s) => {
    const searchableGarageName = s.businessName.toLowerCase();
    return searchableGarageName.includes(searchInputLowerWithoutSpaces);
  });

  return filteredGarages;
};

export const sortGaragesAlphabetically = (garages) => garages.sort((a, b) => a.businessName - b.businessName);

const emptySpecialityCapabilitiesResult = () => ({
  capabilitiesPerGarage: {},
  validSkuCount: 0,
  hadMalformedEntries: true,
});

const isMalformedSkuEntry = (skuEntry) =>
  !skuEntry || typeof skuEntry !== 'object' || !Array.isArray(skuEntry.specialityAssociation);

const isMalformedAssociationEntry = (association) =>
  !association ||
  typeof association !== 'object' ||
  association.specialityOwnerId == null ||
  association.specialityOwnerId === '';

export const getRelevantSpecialitiesForBooking = (specialitiesBySku) => {
  if (!Array.isArray(specialitiesBySku)) {
    console.warn(
      'GaragePickerModal: getRelevantSpecialitiesForBooking expected an array, received:',
      specialitiesBySku
    );
    return emptySpecialityCapabilitiesResult();
  }

  const capabilitiesPerGarage = {};
  let validSkuCount = 0;
  let hadMalformedEntries = false;

  specialitiesBySku.forEach((skuEntry, skuIndex) => {
    if (isMalformedSkuEntry(skuEntry)) {
      hadMalformedEntries = true;
      console.warn(
        'GaragePickerModal: excluding malformed SKU entry (expected object with specialityAssociation array):',
        { skuIndex, skuEntry }
      );
      return;
    }

    validSkuCount += 1;

    skuEntry.specialityAssociation.forEach((association, associationIndex) => {
      if (isMalformedAssociationEntry(association)) {
        hadMalformedEntries = true;
        console.warn(
          'GaragePickerModal: excluding malformed speciality association (expected object with specialityOwnerId):',
          { skuIndex, associationIndex, association }
        );
        return;
      }

      const garageId = association.specialityOwnerId;

      if (!capabilitiesPerGarage[garageId]) capabilitiesPerGarage[garageId] = 0;

      capabilitiesPerGarage[garageId] += 1;
    });
  });

  return {
    capabilitiesPerGarage,
    validSkuCount,
    hadMalformedEntries,
  };
};
